// extracted by mini-css-extract-plugin
export default {"UserAvatar":"+TuUqjz0qtkX8nuX6unTdw==","Notifications":"GH2llsC2XzzMhQLUZR90-Q=="};